import { render, staticRenderFns } from "./originalData.vue?vue&type=template&id=16346ccb&scoped=true&"
import script from "./originalData.vue?vue&type=script&lang=js&"
export * from "./originalData.vue?vue&type=script&lang=js&"
import style0 from "./originalData.vue?vue&type=style&index=0&id=16346ccb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16346ccb",
  null
  
)

export default component.exports